// src/api/backups.ts
import {
  collection,
  getDocs,
  orderBy,
  query,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

export type BackupData = {
  id: string;
  backupDate?: string | Timestamp | Date;
  createdAt?: Timestamp | Date;
  createdBy?: string;
  status?: string;
  [key: string]: any;
};

/**
 * ワークスペースのバックアップ履歴を取得
 * パス: /workspaces/{workspaceId}/backups
 */
export const fetchBackups = async (workspaceId: string): Promise<BackupData[]> => {
  if (import.meta.env.MODE === 'development') {}
  
  const backupsCol = collection(db, `workspaces/${workspaceId}/backups`);
  
  try {
    // backupDate降順で取得
    const qRef = query(backupsCol, orderBy('backupDate', 'desc'));
    const snapshot = await getDocs(qRef);
    
    if (import.meta.env.MODE === 'development') {
      if (!snapshot.empty) {
        const firstDoc = snapshot.docs[0];
      }
    }
    
    const backups: BackupData[] = [];
    snapshot.forEach((doc) => {
      const data = doc.data() as Omit<BackupData, 'id'>;
      backups.push({ ...data, id: doc.id });
    });
    
    if (import.meta.env.MODE === 'development') {}
    
    return backups;
  } catch (error) {
    console.error('❌ [ERROR] fetchBackups error:', error);
    throw error;
  }
};
